<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button
            :pressed="true"
            class="typo-label"
            variant="link"
            >Lista Impianti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtentiPendenti"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtenti"
            >Lista Utenti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaCodiciPro"
            >Gestione Codici Pro</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraAldi"
            >Report Aldi</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && authorized" class="animated fadeIn container-fluid">
            <b-row v-if="!this.advancedFilters">
                <b-col md="10" offset-md="1" lg="6" offset-lg="3" class="py-4 text-center">
                    <b-form-group>
                        <b-input-group>
                        <!-- Attach Left button -->
                        <b-input-group-prepend>
                            <b-input-group-text>Cerca:</b-input-group-text>
                            
                        </b-input-group-prepend>
                        <b-form-input type="text" placeholder="" v-model="searchPlant"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary">
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button class="typo-label;" variant="link" @click="mostraFiltriAvanzati">&raquo; Filtri Avanzati</b-button>
                        </b-input-group-append>
                        </b-input-group>
                        
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="this.advancedFilters">
                <b-col lg="10" offset-lg="1">
                    <b-card header="Filtri Avanzati" header-bg-variant="primary" border-variant="primary" header-text-variant="white" class="mt-2 mb-0 typo-label">
                        <template v-slot:header>
                            <span><strong>Filtri Avanzati</strong></span>
                            <b-button size="sm" variant="primary" @click="mostraFiltriAvanzati()" >&raquo; Ricerca Semplice</b-button>
                            <b-button class="float-right" variant="danger" @click="azzeraFiltri">Azzera Filtri</b-button>
                        </template>                
                        <b-row>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-nomeImpianto" >Nome Impianto</label>
                                    <b-form-input type="text" id="flt-nomeImpianto" v-model="filters.nomeImpianto"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-cittaImpianto" >Città Impianto</label>
                                    <b-form-input type="text" id="flt-cittaImpianto" v-model="filters.cittaImpianto"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-tipoImp" >Tipo Impianto</label>
                                    <b-form-select v-model="filters.tipoImpianto" class="mb-3">
                                        <b-form-select-option value="">Tutti</b-form-select-option>
                                        <b-form-select-option value="basic">Basic</b-form-select-option>
                                        <b-form-select-option value="pro">Pro</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <!-- Massi -->
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-tipoImp" >Tecnologia Impianto</label>
                                    <b-form-select v-model="filters.tecnologiaImpianto" class="mb-3">
                                        <b-form-select-option value="">Tutti</b-form-select-option>
                                        <b-form-select-option value="bluetooth">Bluetooth</b-form-select-option>
                                        <b-form-select-option value="centralized">Centralizzato</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>         
                        <b-row>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-nomeInstallatore">Nome Installatore</label>
                                    <b-form-input type="text" id="flt-nomeInstallatore" v-model="filters.nomeInstallatore"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-emailInstallatore" >Email Installatore</label>
                                    <b-form-input type="text" id="flt-emailInstallatore" v-model="filters.emailInstallatore"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-idCent" >ID Centrale</label>
                                    <b-form-input type="text" id="flt-idCent" v-model="filters.idCent"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <!-- Massi -->
                            <b-col lg="3">
                                <b-form-group>
                                    <label for="flt-tipoCent" >Tipo Centrale</label>
                                    <b-form-select v-model="filters.tipoCentrale" class="mb-3">
                                        <b-form-select-option value="">Tutte</b-form-select-option>
                                        <b-form-select-option value="logica">Logica</b-form-select-option>
                                        <b-form-select-option value="logicaFM">LogicaFM</b-form-select-option>
                                        <b-form-select-option value="cablecom">Cablecom</b-form-select-option>
                                        <b-form-select-option value="sicuro">Sicuro</b-form-select-option>
                                        <b-form-select-option value="blegateway">GatewayBle</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                                <!-- </b-form-group> -->
                            </b-col>
                        </b-row>           
                    </b-card>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col class="center">
                    <b-table id="ntoTable" :per-page="rpp" :current-page="tabPage" sticky-header="500px" 
                        :striped="true" :hover="true" :items="filteredList" :fields="tableFields" 
                        :outlined="true" @row-clicked="selImpianto" sort-icon-left>
                        <template v-slot:cell(plantname)="data">
                            <strong>{{data.value}}</strong><br/>
                            {{clienteImp(data.item)}}
                        </template>
                        <template v-slot:cell(plantType)="{ item: item }">
                            <strong>{{getPlantType(item)}}</strong>
                        </template>
                        <template v-slot:cell(installer)="{ item: item }">
                            {{installerImp(item)}}<br/>
                            {{emailInstallerImp(item)}}
                        </template>
                        <template v-slot:cell(plantTechnology)="{ item: item }">
                            <strong>{{getTechnology(item)}}</strong>
                        </template>
                        <template v-slot:cell(installationDate)="{ item: item }">
                            {{getInstallationDate(item)}}
                        </template>
                        <template #cell(syncDate)="{ item: item }">
                            {{getLastSync(item)}}
                        </template>
                        <!-- <template #cell(syncDate)="data">
                            {{data.item.dataUltimoSync}}
                        </template> -->
                        <template v-slot:cell(tipoCentr)="{ item: item }">
                            <strong>{{getTipoCentrale(item)}}</strong>
                        </template>
                        <template v-slot:cell(address)="data">
                            <strong>{{data.value.city}} ({{data.value.prov}})</strong><br/>
                            {{data.value.street}} {{data.value.housenumber}}
                        </template>
                        <template v-slot:cell(controlunits)="{ item: item }">
                            <strong>{{ countCent(item)}}</strong></br>
                        </template>
                        <template v-slot:cell(lamps)="{ item: item }">
                            <strong>{{ countLamps(item) }}</strong>
                        </template>
                        <template v-slot:cell(errori)="data">
                            <strong :class="{'withError': (data.value > 0)}">{{data.value}}</strong> 
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row class="mt-6">
                <b-col>
                    <b-navbar v-if="userAllPlants != null && userAllPlants.length > 0" type="light" class="bottomNav"> 
                        <b-nav-text class="mx-auto">
                            <span class="totLabel">Totale records filtrati: {{filteredList.length}}</span>
                            <b-pagination
                                v-model="tabPage"
                                :total-rows="filteredList.length"
                                :per-page="rpp"
                                aria-controls="ntoTable"
                                ></b-pagination>
                        </b-nav-text>
                    </b-navbar>  
                </b-col>
            </b-row>
        </div>
    
    </div>


</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import AddPlant from '@/components/AddPlant'
import { mapState, install } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'
import moment from 'moment'

export default {
    name: 'NTOHome',
    components: {
        AddPlant,
        hideAt, showAt

    },    
    props: [],
    data() {
        return {
            advancedFilters: true,
            filters: {
                nomeImpianto: '',
                cittaImpianto: '',
                nomeCent: '',
                idCent: '',
                nomeInstallatore: '',
                emailInstallatore: '',
                tipoImpianto: '',
                tecnologiaImpianto: '',
                tipoCentrale: ''
            },
            userId: null,
            pageloading: true,
            searchPlant: "",
            selectedPlant:"",
            authorized: false,
            dataLoaded: false,
            tabPage: 1,
            rpp: 50,
            tableFields: [
                {
                    key: 'plantname',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'plantType',
                    label: 'Tipo Impianto',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'plantTypeSort'
                }, 
                {
                    key: 'installer',
                    label: 'Installatore'
                },
                {
                    key: 'installationDate',
                    label: 'Data di creazione',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'dateSort'
                },
                {
                    key: 'syncDate',
                    label: 'Data ultimo sync',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'syncSort'
                },                
                {
                    key: 'plantTechnology',
                    label: 'Tecnologia Impianto',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'plantTechnologySort'
                }, 
                {
                    key: 'tipoCentr',
                    label: 'Tipo Centrale',
                },   
                {  
                    key: 'address',
                    label: 'Indirizzo',
                },
                {
                    key: 'controlunits',
                    label: 'Numero Centrali',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'centSort'
                },
                {
                    key: 'lamps',
                    label: 'Numero Lampade',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'lampSort'
                },
                {
                    key: 'errori',
                    label: 'Errori',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'countErrors'
                }
            ]
        }
    },
    created() {
        
    },
    mounted() {
        
        console.log("MOUNTED NTOHOME " + this.pageloading);
    
        this.$store.state.currentPlant = null;
        this.$store.state.userLastPlants = [];

        if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            const usertype = this.$store.getters.userType;
            console.log("ntohome launch loadplants, " + usertype);
            if (usertype != 'admin') {
                this.authorized = false;
                this.pageloading = false;
            } else {
                this.authorized = true;
                this.pageloading = true;
                //this.$store.dispatch('loadAllPlants',  this.$store.state.user.username);
                
                if (this.$store.state.allUsers == null || this.$store.state.allUsers.length == 0) {
                    console.log("carico users");
                    this.$store.dispatch('loadAllUsers',{userId: this.$store.state.user.username});
                } else {
                    this.loadAllPlants();
                }
            }
        } 

        
    },
    updated() {
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
           console.log("updated ntohome");
        }
    },
    computed: {
        ...mapState(['loading']),

        userAllPlants() {
            let all = null;
            if (this.$store.state.userAllPlants != null) {
                all = this.$store.state.userAllPlants;
                all = all.sort((a, b) => b.regdate - a.regdate);
            }
            if (all == null || all.length=="0") return null;           
            console.log("ALL PLANTS", all);
            return all;
        },

        bleAllPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth')
            })
        },

        emptyBleAllPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps==null || item.ble_lamps.length==0))
            })
        },

        centAllPlants(){
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && item.controlunits!=null)
            })
        },

        filteredList() {
            console.log("chiamata filteredList ", this.advancedFilters, " userAllPlants: ", this.userAllPlants);
            let self = this;
            if (this.userAllPlants == null) {
                return [];
            }
            if (this.advancedFilters) {
                let citta = self.filters.cittaImpianto.toLowerCase().trim();
                let nomeCent = self.filters.nomeCent.toLowerCase().trim();
                let idCent = self.filters.idCent.toLowerCase().trim();
                let nomeInstallatore = self.filters.nomeInstallatore.toLowerCase().trim();
                let emailInstallatore = self.filters.emailInstallatore.toLowerCase().trim();
                let tipoImpianto = this.filters.tipoImpianto.toLowerCase().trim();
                let tecnologiaImpianto = this.filters.tecnologiaImpianto.toLowerCase().trim();
                let tipoCentrale = this.filters.tipoCentrale.toLowerCase().trim();
                let number = 1;
                const filtrati = this.userAllPlants.filter(plant => {
                    var matched = true;
                    if (self.filters.nomeImpianto != '') {
                        matched = plant.plantname.toLowerCase().includes(self.filters.nomeImpianto.toLowerCase().trim());
                    }
                    if (matched && self.filters.cittaImpianto != '') {
                        if (plant.address == null) {
                            matched = false;
                        } else if (plant.address.city == null) {
                            matched = false;
                        } else {
                            let city = "" + plant.address.city.toLowerCase();
                            //console.log("plant city:" + city+", citta:" + citta);
                            matched = city.includes(citta);
                        }                        
                    }
                    if (matched && self.filters.nomeCent != '') {
                        var trovataCent = false;
                        let culist = plant.controlunits;
                        if (plant.controlunits == null || plant.controlunits.length == 0) {
                            matched = false;
                        } else {
                            for (var i=0; i< culist.length; i++) {
                                if (culist[i].cudesc != null && culist[i].cudesc.toLowerCase().includes(nomeCent)) {
                                    trovataCent = true;
                                    break;
                                }
                            }
                            matched = trovataCent;
                        }
                    }
                    if (matched && self.filters.idCent != '') {
                        trovataCent = false;
                        let culist = plant.controlunits;
                        if (plant.controlunits == null || plant.controlunits.length == 0) {
                            matched = false;
                        } else {
                            for (i=0; i< culist.length; i++) {
                                if (culist[i].cuid != null && culist[i].cuid.toLowerCase().includes(idCent)) {
                                    trovataCent = true;
                                    break;
                                }
                            }
                            matched = trovataCent;
                        }
                    }
                    if (matched && self.filters.nomeInstallatore != '') {
                        matched = self.installerImp(plant).toLowerCase().includes(nomeInstallatore);
                    }
                    if (matched && self.filters.emailInstallatore != '') {
                        matched = self.emailInstallerImp(plant).toLowerCase().includes(emailInstallatore);
                    }
                    //Massi
                    if (matched && ('' != tipoCentrale)) {
                        if (plant.controlunits == null || plant.controlunits.lenght == 0) {
                            matched = false;
                        } else {
                            matched = false; 
                            //per ogni controlunits presente nell'impianto, verifico se è del tipo voluto
                            plant.controlunits.forEach( (value) => 
                            {                                                           
                                if (value.cutype.toLowerCase() == tipoCentrale) {
                                    matched = true;
                                    console.log(`CENTRALE #${number} ${value.cutype} ${plant.plantname}`);
                                    number++;
                                }
                            } )
                        }
                    }   
                    //Massi
                    if (matched && ('' != tecnologiaImpianto)) {
                        matched = false;
                        if ((plant.technology == undefined) || (plant.technology == null) || (plant.technology == '')) {                            
                            if (tecnologiaImpianto == 'centralized') {
                                console.log(`IMPIANTO ${plant.plantname} CENTRALIZZATO `);
                                matched = true;
                            }
                        } else {
                            if (plant.technology.toLowerCase().includes(tecnologiaImpianto)) {
                                console.log(`IMPIANTO ${plant.plantname} = ${plant.technology}`);
                                matched = true;
                            }
                        } 
                    }

                    if (matched && ('' != tipoImpianto)) {
                        matched = false;
                        if (plant.plant_type != null){
                            if (plant.plant_type.toLowerCase().includes(tipoImpianto)) {
                                console.log(`IMPIANTO ${plant.plantname} = ${plant.technology}`);
                                matched = true;
                            } 
                        }
                    }
                    return matched;
                });
                console.log("FILTERED PLANTS ", filtrati);
                return filtrati;
            }
            if (this.searchPlant == '') return this.userAllPlants;
            return this.userAllPlants.filter(plant => {
                let terms = this.searchPlant.split(" ", -1);
                var matchFound = false;
                for (var i=0; i<terms.length; i++) {
                    //console.log("cerco "+terms[i]+", in ", plant);

                    matchFound = (plant.plantname.toLowerCase().includes(terms[i].toLowerCase()) 
                    || plant.address.street.toLowerCase().includes(terms[i].toLowerCase())
                    || plant.address.city.toLowerCase().includes(terms[i].toLowerCase())
                    || plant.address.prov.toLowerCase().includes(terms[i].toLowerCase())
                    || plant.address.country.toLowerCase().includes(terms[i].toLowerCase())
                    )
                    if (matchFound) return true;

                    if (plant.controlunits != null && plant.controlunits.length >0 ) {
                        
                        for (var cu = 0; cu< plant.controlunits.length; cu++) {
                            //console.log("verifico " + terms[i] + "==" + plant.controlunits[cu].cuid);  
                            if (plant.controlunits[cu].cuid.toLowerCase() == terms[i].toLowerCase()) {
                                //console.log("trovato!", plant);
                                return true;
                            }
                        }
                    }
                }
                return false;

            /*return (plant.plantname.toLowerCase().includes(this.searchPlant.toLowerCase()) 
                    || plant.address.street.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.city.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.prov.toLowerCase().includes(this.searchPlant.toLowerCase())
                    || plant.address.country.toLowerCase().includes(this.searchPlant.toLowerCase())
                    )*/
        })
        },
  
    },  
    watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val);
            if (val == false) {
                this.$store.state.currentPlant = null;
                this.$store.state.userLastPlants = [];
                if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
                    const usertype = this.$store.getters.userType;
                    if (usertype != 'admin') {
                        this.authorized = false;
                        this.pageloading = false;
                    } else {
                        this.authorized = true;
                        if (this.dataLoaded == false) {

                            if (this.$store.state.allUsers == null || this.$store.state.allUsers.length == 0) {
                                console.log("carico users2");
                                this.$store.dispatch('loadAllUsers',{userId: this.$store.state.user.username});
                                return;
                            }

                            this.dataLoaded = true;
                            //this.$store.dispatch('loadAllPlants',  this.$store.state.user.username);
                            this.loadAllPlants();

                        } else {
                            this.pageloading = false
                        }
                    }
                } else {
                    this.pageloading = false
                }
            }
        }
    },        
    methods: {

        //--------------------------------------------------------------------
        // restituisce la data dell'ultimo sincronismo effettuato, andando a 
        // confrontare le date di ogni lampada (il sync è legato alle singole lampade)
        //--------------------------------------------------------------------
        getLastSync(plant) {
            if (plant.technology === 'bluetooth' && plant.ble_lamps != null) {
                var lastSyncDate=moment('2023-01-01').toDate();
                for (var k=0; k<plant.ble_lamps.length; k++ )
                {
                    var lamp = plant.ble_lamps[k];
                    var tempDate = moment(lamp.last_sync).toDate();
                    //console.log("Last sync lamp: " + k + " : ", tempDate);
                    if (tempDate>lastSyncDate)
                        lastSyncDate = tempDate;
                }
                plant.lastSyncDate = lastSyncDate; //***
                return moment(lastSyncDate).format('DD-MM-YYYY')
            }
        },

        // sortLastSync(plant) {
        //     if (plant.technology === 'bluetooth' && plant.ble_lamps != null) {
        //         var lastSyncDate=moment('2023-01-01').toDate();
        //         for (var k=0; k<plant.ble_lamps.length; k++ )
        //             {
        //                 var lamp = plant.ble_lamps[k];
        //                 var tempDate = moment(lamp.last_sync).toDate();
        //                 //console.log("Last sync lamp: " + k + " : ", tempDate);
        //                 if (tempDate>lastSyncDate)
        //                     lastSyncDate = tempDate;
        //             }       
        //         console.log("Last sync plant", lastSyncDate);
        //         return lastSyncDate
        //     }            
        // },

        azzeraFiltri() {
            this.filters = {
                nomeImpianto: '',
                cittaImpianto: '',
                nomeCent: '',
                idCent: '',
                nomeInstallatore: '',
                emailInstallatore: '',
                tecnologiaImpianto: '',
                tipoImpianto: '',
                tipoCentrale: ''
            }
        },
        mostraFiltriAvanzati() {
            this.advancedFilters = !this.advancedFilters;
        },

        loadAllPlants() {
            this.$store.dispatch('loadAllPlantsPost',{userId: this.$store.state.user.username});
        },

        mostraPaginaUtenti() {
            router.push({ name: 'NTOUsers'})
        },

        mostraPaginaUtentiPendenti() {
            router.push({ name: 'NTOPendingUsers'})
        },

        mostraPaginaCodiciPro() {
            router.push({ name: 'NTOProCodes'})
        },

        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },

        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },

        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },

        selImpianto(item,index,ev) {
            console.log("selezionato impianto",item,index,ev);

            this.$store.state.currentPlant = item;
            this.$store.state.userLastPlants = [item];
            console.log('ora last plants =', this.$store.state.userLastPlants)
            router.push({ name: 'HomeImpianto', params: { pid: item.id } })

        },

        lensClicked(e) {
            e.preventDefault();
            this.listVisible = true;
        },



        //------------------------------------------------------------------------------------------------------------------
         // function: countLamps(plant)
        //
        // output: il numero di lampade installate
        //------------------------------------------------------------------------------------------------------------------
        countLamps(plant) {
            if(plant!=null)
            {
                if (this.getTechnology(plant) == "Centralizzato")  {
                    if (plant.controlunits == null) return 0;
                    var nlamp = plant.controlunits.reduce(function(acc,unit) {
                        return acc + (unit.num_lamp_found || 0);
                    },0);
                    return nlamp;
                }
                else {
                    if (plant.ble_lamps == null) return 0;
                    return plant.ble_lamps.length;
                }
            }
        },

        countCent(plant) {
            if(plant!=null)
            {
                if (plant.controlunits == null) return 0;
                return plant.controlunits.length;
            }
        },

        cuAllPlants()
        {
            var allCu=[];
            for(var k=0;k<this.centAllPlants.length;k++)
                if(this.getCuPlant(this.centAllPlants[k])!=null)
                {
                    allCu=allCu.concat(this.getCuPlant(this.centAllPlants[k]));
                }
            return allCu;    
        },

        bleLampsAllPlants()
        {
            var allBleLamps=[];
            for(var k=0;k<this.bleAllPlants.length;k++)
                if(this.bleAllPlants[k].ble_lamps!=null)
                {
                    allBleLamps=allBleLamps.concat(this.bleAllPlants[k].ble_lamps);
                }
            return allBleLamps;    
        },

        cuCablecomAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="cablecom")
            })
        },

        cuLogicaAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="logica")
            })
        },

        cuLogicaFMAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="logicafm")
            })
        },

        cuSicuroAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="sicuro")
            })
        },

        cuGatewayAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="gatewayble")
            })
        },

        getCuPlant(plant) {
            if(plant!=null)
            {
                if (plant.controlunits != null) 
                  return plant.controlunits;
            }
        },

        clienteImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.filter(function(u) {
                return u.role == 'client'
            });
            if (cli == null || cli.length == 0) return ""
            return cli[0].nome;
        },

        installerImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.find(function(u) {
                return u.role == 'installer'
            });
            if (cli == null ) return ""
            //console.log("intaller",cli);
            if (cli.nome == null) {
            const allUsers = this.$store.state.allUsers;
            if (allUsers != null) {
                let installer = allUsers.find(u => {
                    //console.log("user-->" + u.id + " " + u.businessname+", " + cli[0].userid);
                    return u.id == cli.userid;
                });
                if (installer != null) {
                    if (installer.businessname != null && installer.businessname != '') {
                        cli.nome = installer.businessname;
                        return installer.businessname;
                    } 
                    cli.nome =installer.surname + ' ' + installer.name;
                    return installer.surname + ' ' + installer.name;
                }
            }
            }
            return cli.nome || "N.D.";
        },

        emailInstallerImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.find(function(u) {
                return u.role == 'installer'
            });
            if (cli == null ) return ""
            //console.log("intaller",cli);
            if (cli.email == null) {
            const allUsers = this.$store.state.allUsers;
            if (allUsers != null) {
                let installer = allUsers.find(u => {
                    //console.log("user-->" + u.id + " " + u.businessname+", " + cli[0].userid);
                    return u.id == cli.userid;
                });
                if (installer != null) {
                    //console.log("installer->",installer);
                    //if (installer.email != null && installer.email != '') {
                        cli.email = installer.username;
                        return installer.username;
                    //} 
                }
            }
            }
            return cli.email || "N.D.";
        },

        dateSort(value,key,item) {
            if(item.regdate!=null)
                return (item.regdate > 0) ? item.regdate : 0
        },

        // syncSort(value, key, item) {
        //     console.log("ITEM: ", value, key, item);
        //     if (item != null) {
        //         if(item.technology != null) {
        //             return (this.sortLastSync(item) > 0) ? this.sortLastSync(item) : 0
        //         } else {
        //             return 0;
        //         }
        //     }
        // },

        syncSort(value, key, item) {
            // console.log("ITEM: ", value, key, item);
            if (item != null) {
                if(item.technology != null) {
                    //return (moment(item.dataUltimoSync).valueOf() > 0) ? moment(item.dataUltimoSync).valueOf() : 0
                    return (item.lastSyncDate > 0) ? item.lastSyncDate : 0
                } else {
                    return 0;
                }
            }
        },

        lampSort(value,key,item) {
            return (this.countLamps(item) > 0) ? this.countLamps(item) : 0
        },

        centSort(value,key,item) {
            return (this.countCent(item) > 0) ? this.countCent(item) : 0
        },

        plantTechnologySort(value,key,item) {
            return (item.technology=="bluetooth")? 1 : 0
        },

        plantTypeSort(value,key,item) {
            return (item.plant_type=="pro")? 1 : 0
        },

        countErrors(value,key,item) {

            if (item == null || item.controlunits == null) return 0;
            var nlamp = item.controlunits.reduce(function(acc,unit) {
                return acc + (unit.num_lamp_error || 0);
            },0);
            return (nlamp > 0) ? nlamp : 0

        //console.log("countErrors for:",a,b,c,d);
        /*if (units == null) return 0;
        var nlamp = units.reduce(function(acc,unit) {
            return acc + unit.num_lamp_error;
        },0);
        //if (nlamp > 0) return "<span style=\"color: red\">" + nlamp + "</span>";
        //return "0";
        return (nlamp > 0) ? nlamp : 0;*/
        //return "XX"
        
        },

        //------------------------------------------------------------------------------------------------------------------
        //
        // function: getTipoImpianto(<record di Plants>)
        //
        // output: se nel record di Plants non  esiste il campo 'technology', introdotto con i nuovi impianti Bluetooth,
        // allora si assume che sia un impianto 'Centralizzato'
        //------------------------------------------------------------------------------------------------------------------
        getTechnology(imp) {
            if (imp!=null)
            {
                if (imp.technology == "bluetooth") 
                {
                    return "Bluetooth";
                } 
                // else {
                //     if (imp.technology == "centralized") {
                //         return "Centralizzato"
                //     } else {
                //         return "aaaaaa"
                //     }
                // }
                else {
                    return "Centralizzato";
                }  
            } 
        },

        getPlantType(imp) {
            if (imp!=null)
            {
                if(imp.plant_type == "pro") 
                {
                    return "Pro";
                }
                else {
                    return "Basic";
                }  
            } 
        },


        getInstallationDate(imp) {
            return moment(imp.regdate).format("DD MMM YYYY");
        },


        //------------------------------------------------------------------------------------------------------------------
        //
        // function: getTipoCentrale(<record di Plants>)
        //
        // output: l'elenco delle tipologie di centrale presenti nell'impianto, come risulta dall'array 'controlunits'
        // di Plants
        //------------------------------------------------------------------------------------------------------------------
        getTipoCentrale(imp) { 
            if (imp.controlunits == null || imp.controlunits.lenght == 0 || imp.controlunits == "") {
                return "nessuna";
            } else {
                //per ogni controlunits presente nell'impianto
                let risp = ""
                imp.controlunits.forEach( (value) => { 
                    let strCorretta = ""
                    switch (value.cutype) {
                        case "blegateway":
                            strCorretta = "GatewayBle";
                            break;
                        case "sicuro230":
                            strCorretta = "Sicuro230";
                            break;
                        case "cablecom":
                            strCorretta = "Cablecom";
                            break;
                        case "logica":
                            strCorretta = "Logica";
                            break;
                        case "logicafm":
                            strCorretta = "LogicaFM";
                            break;
                        default:
                            strCorretta = value.cutype;
                    }         
                    if (!risp.includes(strCorretta)) {
                        if (risp == "") {
                            risp = strCorretta;
                        } else  {   
                            risp = risp + ', ' + strCorretta;
                        }
                    }   
                } )
                return risp;
            }
        },   
    }
    

}
</script>

<style lang="scss" scoped>
    .bottomNav {
        bottom:20px;
        //background-color: #fff;
    }
    .totLabel {
        font-family: 'Roboto',sans-serif;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    

</style>